<template>
  <div v-if="isEnabledReExaminationDetail()">
    <div v-if="detailData.orderType == '企業検診'">
      <div v-for="(detail, index) in corpReExaminationDetailList" :key="index">
        <div class="detail-contents card-content margin-top">
          <div class="card-title">再検査情報{{ index + 1 }}</div>
          <table>
            <tr>
              <th>No.</th>
              <td>
                {{ detail.receptionNo }}
              </td>
            </tr>
            <tr>
              <th>被験者名</th>
              <td>
                {{ detail.patientName }}
              </td>
            </tr>
            <tr>
              <th>状態</th>
              <td>
                <div class="flex">
                  <div
                    class="status-card"
                    :class="
                      getTabClass4RequestStatus(requestStatus.reInspection)
                    "
                  >
                    {{ getProgres(requestStatus.reInspection) }}
                  </div>
                  <div v-show="showButtons" class="re-examination-button-area">
                    <b-button
                      class="is-primary w-150"
                      @click="
                        confirmReExamination(detail.receptionNo, detail.version)
                      "
                      >再検査を実施する</b-button
                    >
                    <b-button
                      class="is-primary w-150"
                      @click="cancelOrder(detail.receptionNo, detail.version)"
                      >検査をキャンセル</b-button
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>再検査調整依頼日</th>
              <td>
                <p class="re-examination-date">{{ detail.date }}</p>
              </td>
            </tr>
            <tr>
              <th>再検査理由</th>
              <td>
                <p class="re-examination-text">{{ detail.memo }}</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div v-else class="detail-contents card-content margin-top">
      <div class="card-title">再検査情報</div>
      <table>
        <tr>
          <th>状態</th>
          <td>
            <div class="flex">
              <div
                class="status-card"
                :class="getTabClass4RequestStatus(requestStatus.reInspection)"
              >
                {{ getProgres(requestStatus.reInspection) }}
              </div>
              <div v-show="showButtons" class="re-examination-button-area">
                <b-button
                  class="is-primary w-150"
                  @click="
                    confirmReExamination(
                      reExaminationDetail.receptionNo,
                      reExaminationDetail.version
                    )
                  "
                  >再検査を実施する</b-button
                >
                <b-button
                  class="is-primary w-150"
                  @click="
                    cancelOrder(
                      reExaminationDetail.receptionNo,
                      reExaminationDetail.version
                    )
                  "
                  >検査をキャンセル</b-button
                >
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>再検査調整依頼日</th>
          <td>
            <p class="re-examination-date">{{ reExaminationDetail.date }}</p>
          </td>
        </tr>
        <tr>
          <th>再検査理由</th>
          <td>
            <p class="re-examination-text">{{ reExaminationDetail.memo }}</p>
          </td>
        </tr>
      </table>
    </div>

    <b-modal :active.sync="cancelModalActive" has-modal-card>
      <ReasonInputModal @setReason="executeCancel" :title="CancelModalTitle" />
    </b-modal>

    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-label="Example Modal"
      aria-modal>
      <div class="modal-card" style="width: 650px;">
        <header class="modal-card-head">
        </header>
        <section class="modal-card-body">
          <div id="item-contens">
            <div v-html="reExaminationMessage"/>
            <div class="card-content margin-top">
              <table>
                <tr>
                  <th>受付番号</th>
                  <td>{{reExaminationDetail.receptionNo}}</td>
                </tr>
                <tr>
                  <th>シリアル番号<span class="require" /></th>
                  <td>
                    <select v-model="selectedSerial" validate="required" class="validate" name="シリアル番号">
                      <option v-for="availableHolter in availableHolterList" :value="availableHolter.serial" :key="availableHolter.serial">{{ availableHolter.serial }}</option>
                    </select>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div style="margin:auto;">
            <b-button @click="isComponentModalActive=false">{{reExaminationCancelText}}</b-button>
            <b-button @click="depositReExaminationConfirm(reExaminationDetail.receptionNo, reExaminationDetail.version)">{{reExaminationConfirmText}}</b-button>
          </div>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  requestStatus,
  reExaminationConfirmTemplate,
} from "../../base/const.js";
import ReasonInputModal from "../../philips/common/reasonInputModal.vue";

const TYPE_HST = "HST";
const TYPE_COMPANY = "company";
const TYPE_HOLTER = "Holter";

const RE_EXAM_SUCCESS_MESSAGE = `再検査を受け付けました。<br>
                                 <br>
                                 再検査の出荷日は、<br>
                                 検査申請一覧 → 受付番号をクリック → 配送情報<br>
                                 よりご確認いただけます。
                                `;
const RE_EXAM_HOLTER_DEPOSIT_SUCCESS_MESSAGE = `再検査を受け付けました。`;
const ERROR_MESSAGE_OBJ = { memo: "再検査情報を取得できませんでした" };
const RE_EXAMINATION_CONFIRM_MESSAGE = "<div style='Text-align: left'>" + "再検査の依頼は下記のOKボタンを押してください" + "</div>"

export default {
  data() {
    return {
      // import module
      requestStatus,

      // cancel modal
      CancelModalTitle: "検査キャンセル(キャンセル理由入力)",
      cancelModalActive: false,
      cancelReceptionNumber: "",
      cancelVersion: "",

      // show re exam or cancel button?
      showButtons: true,

      // response list
      reExaminationDetail: {},
      corpReExaminationDetailList: [],
      isComponentModalActive: false,
      reExaminationMessage: RE_EXAMINATION_CONFIRM_MESSAGE,
      reExaminationCancelText: reExaminationConfirmTemplate.cancelText,
      reExaminationConfirmText: reExaminationConfirmTemplate.confirmText,
      availableHolterList:{},
      selectedSerial:"",
      searchConditions:{
        receiptNumber:"",
        model:"301",
        client:"",
        hospital:"",
        patientName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        shippingDateStart:"",
        shippingDateEnd:""
      },
    };
  },

  props: {
    detailData: {
      type: Object,
      default: {
        externalOperation: false,
        progress: 0,
        receiptNumber: "",
        orderType: "",
        depositMachineFlag: false,
      },
    },
  },

  components: {
    ReasonInputModal,
  },

  methods: {
    isEnabledReExaminationDetail() {
      return (
        this.detailData.externalOperation &&
        this.detailData.progress == requestStatus.reInspection
      );
    },
    getReExaminationDetail() {
      if (this.isEnabledReExaminationDetail()) {
        let orderType = this.setOrderType();
        const THIS = this;

        this.apiCall(
          (client) => {
            return client.apis.externalRequestSearch.getHistoryDetail({
              body: {
                receptionNo: THIS.detailData.receiptNumber,
                orderType: orderType,
                status: this.requestStatus.reInspection,
              },
            });
          },
          (result) => {
            if (orderType == TYPE_COMPANY) {
              THIS.corpReExaminationDetailList = result.obj.historyDetailList;
            } else {
              THIS.reExaminationDetail = result.obj.historyDetail;
            }
            THIS.showButtons = true;
          },
          (error) => {
            if (orderType == TYPE_COMPANY) {
              THIS.corpReExaminationDetailList = [ERROR_MESSAGE_OBJ];
            } else {
              THIS.reExaminationDetail = [ERROR_MESSAGE_OBJ];
            }
            THIS.showButtons = false;
          }
        );
      }
    },

    setOrderType() {
      let orderType = this.detailData.orderType;
      switch (this.detailData.orderType) {
        case "企業検診":
          orderType = TYPE_COMPANY;
          break;
        default:
          break;
      }
      return orderType;
    },

    // re-exmaine methods
    confirmReExamination(receptionNo, version) {
      if(this.detailData.orderType == TYPE_HOLTER && this.detailData.depositMachineFlag){
        var excuteApi = this.getHolterDepositMachineRequestListPOST;
        var successCallBack = this.getHolterDepositMachineRequestListPOSTSuccess;
        var errorCallBack = this.getHolterDepositMachineRequestListPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);

        this.isComponentModalActive = true;
      } else {
        this.$dialog.confirm({
          title: "　",
          message: reExaminationConfirmTemplate.message,
          cancelText: reExaminationConfirmTemplate.cancelText,
          confirmText: reExaminationConfirmTemplate.confirmText,
          onConfirm: () => {
            this.reExaminationExecute(receptionNo, version);
          },
        });
      }
    },
    getHolterDepositMachineRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.externalHolter.getHolterDepositMachineRequestListPOST({
        body:obj
      });
    },
    getHolterDepositMachineRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.availableHolterList = result.obj
    },
    getHolterDepositMachineRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    depositReExaminationConfirm(receptionNo, version){
      // バリデーションチェック
      let elements = document.getElementsByClassName("validate")
      let result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return;
      }
      this.reExaminationExecute(receptionNo, version);
    },

    async reExaminationExecute(receptionNo, version) {
      switch (this.setOrderType()) {
        case TYPE_HST:
          this.reExamineIndividualOrder(receptionNo, version, "hst");
          break;

        case TYPE_HOLTER:
          this.reExamineIndividualOrder(receptionNo, version, "holter");
          break;

        case TYPE_COMPANY:
          this.reExamineCorpOrder(receptionNo, version);
          break;

        default:
          break;
      }
    },

    reExamineIndividualOrder(receptionNo, version, orderType) {
      const THIS = this;
      let shortestShippingDateList = this.getShortestShippingDate();
      let serial = this.selectedSerial

      if(orderType == "holter" && this.detailData.depositMachineFlag){
        this.apiCall(
          function (client) {
            return client.apis.internalRequestSearch.doReInspectionPOST({
              body: {
                kind: orderType,
                receiptNumber: receptionNo,
                shortestShippingDateList: shortestShippingDateList,
                serial: serial,
                version: version,
              },
            });
          },
          function (result) {
            THIS.$dialog.alert({
              title: "　",
              message: RE_EXAM_HOLTER_DEPOSIT_SUCCESS_MESSAGE,
              onConfirm: THIS.reload,
            });
          },
          function (error) {
            THIS.showErrorMessage(error);
          }
        );
      } else {
        this.apiCall(
          function (client) {
            return client.apis.internalRequestSearch.doReInspectionPOST({
              body: {
                kind: orderType,
                receiptNumber: receptionNo,
                shortestShippingDateList: shortestShippingDateList,
                version: version,
              },
            });
          },
          function (result) {
            THIS.$dialog.alert({
              title: "　",
              message: RE_EXAM_SUCCESS_MESSAGE,
              onConfirm: THIS.reload,
            });
          },
          function (error) {
            THIS.showErrorMessage(error);
          }
        );
      }
    },

    reExamineCorpOrder(receptionNo, version) {
      const THIS = this;
      let shortestShippingDateList = this.getShortestShippingDate();

      this.apiCall(
        (client) => {
          return client.apis.internalKenshin.setKenshinRequestInspectionAgainPOST(
            {
              body: {
                receiptNumber: receptionNo,
                shortestShippingDateList: shortestShippingDateList,
                version: version,
              },
            }
          );
        },
        (result) => {
          THIS.$dialog.alert({
            title: "　",
            message: RE_EXAM_SUCCESS_MESSAGE,
            onConfirm: THIS.reload,
          });
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },

    // cancel methods
    cancelOrder(receptionNo, version) {
      this.cancelReceptionNumber = receptionNo;
      this.cancelVersion = version;
      this.cancelModalActive = true;
    },

    executeCancel(cancelReason) {
      switch (this.setOrderType()) {
        case TYPE_HST:
          this.executeCancelIndividualOrder(cancelReason, "hst");
          break;

        case TYPE_HOLTER:
          this.executeCancelIndividualOrder(cancelReason, "holter");
          break;

        case TYPE_COMPANY:
          this.executeCancelCorpOrder(cancelReason);
          break;

        default:
          break;
      }
    },

    executeCancelIndividualOrder(cancelReason, orderType) {
      const THIS = this;

      this.apiCall(
        function (client) {
          return client.apis.internalRequestSearch.cancelInspectionPOST({
            body: {
              kind: orderType,
              receiptNumber: THIS.cancelReceptionNumber,
              reason: cancelReason,
              version: THIS.cancelVersion,
            },
          });
        },
        function (result) {
          THIS.showSuccess(result, THIS.reload);
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },

    executeCancelCorpOrder(cancelReason) {
      const THIS = this;

      this.apiCall(
        (client) => {
          return client.apis.internalKenshin.setKenshinRequestInspectionCancelPOST(
            {
              body: {
                receiptNumber: THIS.cancelReceptionNumber,
                reason: cancelReason,
                version: THIS.cancelVersion,
              },
            }
          );
        },
        (result) => {
          THIS.showSuccess(result, THIS.reload);
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },

    reload() {
      this.$root.$children[0].loadingStart();
      this.$router.go({ path: "/guest/RequestFormList", force: true });
    },
  },

  created() {
    this.getReExaminationDetail();
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.w-150 {
  width: 150px;
}
.card-title {
  font-size: 20px;
  margin-bottom: 0.5em;
}
.status-card {
  width: 120px !important;
  height: 30px !important;
}
.re-examination-text {
  word-break: break-word;
}
.re-examination-button-area {
  margin-left: 1.5em;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/components/ReExaminationDetailPart.vue